/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

"use client";

import { CosmosComponentContextProps } from "@cosmos/components";
import { useAuth } from "@cosmos/next-hooks";
import { AppContextProvider } from "@epic-mw/app-context";

import { TemplateProviders } from "../templates/TemplateProviders";

import { Agreement, AgreementProps } from "./Agreement";

interface Props {
	location: string;
	componentContext: CosmosComponentContextProps;
	agreement: AgreementProps;
}

export const CosmosAgreementClient = ({ location, componentContext, agreement }: Props): React.JSX.Element => {
	useAuth();

	return (
		<AppContextProvider location={location}>
			<TemplateProviders componentContext={componentContext}>
				<Agreement {...agreement} />
			</TemplateProviders>
		</AppContextProvider>
	);
};
